import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function deleteTableView(
  id: string,
): Promise<{ success: boolean; error?: string }> {
  try {
    const res = await fetcher(
      `${API_BASE_PATH}/${id}`,
      {
        method: 'DELETE',
      },
      undefined
    );

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.message || 'Failed to delete table view',
      };
    }

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: 'Failed to delete table view',
    };
  }
}
